export default __webpack_public_path__ + "static/media/diners.51bc4958.svg";